import { useField } from "formik";
import {
  DisplayFormErrors,
  InputField,
  VerticalForm,
  DebugForm,
  SwitchField,
  EfsMelcoEfsModelsMappingOutput,
} from "melco-shared-logic";
import { Col, DesignTokens, FullWidthSpace, Row } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useServiceType } from "../../hooks/designMappings/useServiceType";
import { useInputFormat } from "../../hooks/inputFormats/useInputFormat";
import { DesignConfiguration } from "./DesignConfiguration";
import { FoldernameRules } from "./FoldernameRules";
import { ProcessingConditions } from "./ProcessingConditions";
import { SelectInputFormat } from "./SelectInputFormat";
import { SelectService } from "./SelectService";
import { useEffect } from "react";

const { spacings } = DesignTokens;

export const DisplayDesignMappingDetailForm: React.FC = () => {
  const { t } = useTranslation();

  const [{ value: formatId }] = useField<string | undefined>("format_id");
  const { data: inputFormat } = useInputFormat(formatId);
  const [{ value: outputs }] = useField<
    EfsMelcoEfsModelsMappingOutput[] | null
  >("outputs");

  const { serviceType, isPrint } = useServiceType();

  useEffect(() => {
    // if "Generate production files if production data is empty"  is false
    // (outputs[0].output_production_file_on_emptydata)
    // then all the "Delete text when empty" and "Delete when color value empty" will get false
    // that is "is_delete_empty"

    if (!outputs?.[0].output_production_file_on_emptydata) {
      if (outputs?.[0]?.elements) {
        for (let i = 0; i < outputs[0].elements.length; i++) {
          outputs[0].elements[i].is_delete_empty = false;
        }
      }
    }

    // if "Generate production files if production data is empty" is true
    // if it is print, then no display of switch button "is_delete_empty"
    // so is_delete_empty will be false
    if (outputs?.[0].output_production_file_on_emptydata && isPrint) {
      if (outputs?.[0]?.elements) {
        for (let i = 0; i < outputs[0].elements.length; i++) {
          outputs[0].elements[i].is_delete_empty = false;
        }
      }
    }
  }, [outputs?.[0].output_production_file_on_emptydata]);

  return (
    <>
      <VerticalForm>
        <DisplayFormErrors />

        <FullWidthSpace direction="vertical">
          <div>
            <InputField
              name="name"
              label={t("designMappings.detail.form.label.name")}
            />

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <SelectInputFormat isDisabled />
              </Col>
              <Col xs={24} md={12}>
                <SelectService isDisabled />
              </Col>
            </Row>
          </div>

          <ProcessingConditions inputFormat={inputFormat} />

          <DesignConfiguration
            inputFormat={inputFormat}
            serviceType={serviceType ?? "embroidery"}
          />

          <FoldernameRules inputFormat={inputFormat} />

          <div>
            {isPrint && (
              <>
                <SwitchField
                  name="outputs[0].print_settings.export_layers"
                  label={t("designMappings.detail.form.label.export_layers")}
                />

                <SwitchField
                  name="outputs[0].print_settings.hide_unavailable_layers"
                  label={t(
                    "designMappings.detail.form.label.hide_unavailable_layers"
                  )}
                />
              </>
            )}

            <SwitchField
              name="outputs[0].output_production_file_on_emptydata"
              label={t(
                "designMappings.detail.form.label.output_production_file_on_emptydata"
              )}
            />
          </div>
        </FullWidthSpace>
      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
